import * as actionTypes from './actionMenuActionTypes';

const initialState = {
    ActionMenuAnchorEl: null,
    ActionMenuPlacement: "",
    ActionMenuOpen: false,
    ActionMenuId: undefined

}

export default function actionMenuReducer(state = initialState, action) {

    switch (action.type) {
        case (actionTypes.SET_ACTION_MENU_ANCHOR_EL):
            if (action.anchorEl !== state.ActionMenuAnchorEl) {
                return Object.assign({}, state, { ActionMenuAnchorEl: action.anchorEl });
            }
            return state

        case (actionTypes.SET_ACTION_MENU_PLACEMENT):
            if (action.placement !== state.ActionMenuPlacement) {
                return Object.assign({}, state, { ActionMenuPlacement: action.placement });
            }
            return state
        case (actionTypes.SET_ACTION_MENU_OPEN):
            if (action.open !== state.ActionMenuOpen) {
                return Object.assign({}, state, { ActionMenuOpen: action.open });
            }
            return state

        case (actionTypes.SET_ACTION_MENU_ID):
            if (action.id !== state.ActionMenuId) {
                return Object.assign({}, state, { ActionMenuId: action.id });
            }
            return state
        default:
            return state;
    }
}


